import { combineReducers } from '@reduxjs/toolkit';

import { authenticationReducer } from 'theSource/features/Login/services';
import { enrollmentStatusReducer } from 'enrollment/components/BottomNavigation/services';
import { headerReducer } from 'enrollment/components/Header/components/EnrollmentNavigation/services';
import { enrollmentContextReducer } from 'theSource/features/Home/components/EnrollmentBanner/services';
import { chooseAvatarReducer } from 'enrollment/features/ProfileEdit/Avatar/services/AvatarReducer';
import { profileApiReducer } from 'enrollment/features/ProfileEdit/ManageProfile/slice';
import { profileReducer } from 'enrollment/features/Profile/services';
import { dependentsReducer } from 'enrollment/features/Family/services';
import { beneficiaryReducer } from 'enrollment/features/AddYourBeneficiaries/services';
import {
  answeredSurveyQuestions,
  lifeEventCompletedReducer,
  perPayPeriodTextReducer,
  newHsaContributionReducer,
  DisplayPostElectionReducer,
} from 'enrollment/services';
import { toDoListReducer } from 'enrollment/features/ToDoList/services';
import { DecisionIQEnabledReducer } from 'enrollment/services/DecisionIQEnabled/slice';
import { benefitCategories } from 'enrollment/services/BenefitCategories/slice';
import { benefitsApi } from 'enrollment/services/Benefit/slice';
import { coveragesByCategory } from 'enrollment/services/CoveragesByCategory';
import { eSignCardReducer } from 'enrollment/features/BenefitDetails/services';
import { storeBeneficiarySelection } from 'enrollment/features/AddYourBeneficiaries/slice';
import { homePageReducer } from 'features/HomePage/services/slice';
import { ProviderInfoReducer } from 'enrollment/features/Plans/PlanCard/components/ChoosePCPDrawer/ProvideInfoDrawer/services/slice';
import { SearchProviderApiReducer } from 'enrollment/features/Plans/PlanCard/components/ChoosePCPDrawer/services';
import { PCPFamilyInfoLogicReducer } from 'enrollment/features/Plans/PlanCard/components/ChoosePCPDrawer/SearchResultsPCPDrawer/services';
import { oliveChatReducer } from 'enrollment/services/OliveChat/';

export const enrollmentReducer = combineReducers({
  authentication: authenticationReducer,
  enrollmentContext: enrollmentContextReducer,
  subscriber: profileReducer,
  dependents: dependentsReducer,
  chooseAvatar: chooseAvatarReducer,
  profileReducer: profileApiReducer,
  beneficiary: beneficiaryReducer,
  enrollmentStatus: enrollmentStatusReducer,
  header: headerReducer,
  lifeEventCompleted: lifeEventCompletedReducer,
  toDoList: toDoListReducer,
  decisionIQEnabled: DecisionIQEnabledReducer,
  benefitsApi: benefitsApi,
  benefitCategories: benefitCategories,
  coveragesByCategory: coveragesByCategory,
  storeBeneficiarySelection: storeBeneficiarySelection,
  homepage: homePageReducer,
  providerInfoReducer: ProviderInfoReducer,
  answeredSurveyQuestions: answeredSurveyQuestions,
  searchProviderApiReducer: SearchProviderApiReducer,
  pcpFamilyInfoLogicReducer: PCPFamilyInfoLogicReducer,
  eSignCard: eSignCardReducer,
  perPayPeriodText: perPayPeriodTextReducer,
  newHsaContributions: newHsaContributionReducer,
  oliveChat: oliveChatReducer,
  postElectToast: DisplayPostElectionReducer,
});
